
import { Mapper } from "../../../../base/utils/mapper";
import { TransferPhysiotherapyResponseModel } from "../../../../domain/models/consult/transfer-physiotherapy.response.model";
import { TransferPhysiotherapyResponseEntity } from "../entities/transfer-physiotherapy.response.entity";
export class TransferPhysiotherapyImplementationRepositoryRepositoryMapper extends Mapper<TransferPhysiotherapyResponseEntity, TransferPhysiotherapyResponseModel>{
            mapFrom(param:  TransferPhysiotherapyResponseEntity):  TransferPhysiotherapyResponseModel { 
                return {
                    data:param.data,
                    isSuccess:param.isSuccess,
                    message:param.message,
                    errors:param.errors
                }; 
            }
            mapTo(param:  TransferPhysiotherapyResponseModel):  TransferPhysiotherapyResponseEntity {
                return {
                    data:param.data,
                    isSuccess:param.isSuccess,
                    message:param.message,
                    errors:param.errors 
                };
            }
        }